import type { FC } from 'react';
import { useWatch } from 'react-hook-form';
import { MarketingProcessCode } from '../../../../constants';
import { isScalingEgProcess } from '../../utils/marketingProcess';
import CreativeListCard from './CreativeListCard';
import { ColumnStack } from './LaunchPreview.styles';
import { useCreativePreviewData } from './hooks';
import type { LaunchPreviewValues } from './types';
import { creativesCountLabel, resolveAdTypeName } from './utils';

const ScalingPacksPreview: FC = () => {
  const packsWithCreatives = useWatch<LaunchPreviewValues, 'packsWithCreatives'>({
    name: 'packsWithCreatives',
  });
  const { lookup, adTypeNames } = useCreativePreviewData();

  return (
    <ColumnStack>
      {(packsWithCreatives ?? []).map((pack, index) => (
        <CreativeListCard
          key={`${pack.tag}-${pack.adType ?? ''}-${String(index)}`}
          headerLabel="Pack name"
          countLabel={creativesCountLabel(pack.creatives.length)}
          typeLabel={resolveAdTypeName(adTypeNames, pack.adType)}
          creativeIds={pack.creatives}
          lookup={lookup}
        />
      ))}
    </ColumnStack>
  );
};

const ScalingEgCreativesPreview: FC = () => {
  const selectedCreatives = useWatch<LaunchPreviewValues, 'selectedCreatives'>({
    name: 'selectedCreatives',
  });
  const adType = useWatch<LaunchPreviewValues, 'adType'>({ name: 'adType' });
  const { lookup, adTypeNames } = useCreativePreviewData();

  return (
    <CreativeListCard
      headerLabel="Creatives"
      countLabel={creativesCountLabel(selectedCreatives?.length ?? 0)}
      typeLabel={resolveAdTypeName(adTypeNames, adType)}
      creativeIds={selectedCreatives ?? []}
      lookup={lookup}
    />
  );
};

const CreativesPreview: FC = () => {
  const marketingProcess = useWatch<LaunchPreviewValues, 'marketingProcess'>({
    name: 'marketingProcess',
  });

  if (isScalingEgProcess(marketingProcess)) {
    return <ScalingEgCreativesPreview />;
  }

  if (marketingProcess === MarketingProcessCode.SCALING) {
    return <ScalingPacksPreview />;
  }

  return null;
};

export default CreativesPreview;
